/* Redux saga class
 * logins the user into the app
 * requires username and password.
 * un - username
 * pwd - password
 */
import { put, call } from 'redux-saga/effects';
import * as loginActions from '../actions/loginActions';
//import NavigationService from '../navigation/NavigationService';
import * as Constants from '../config/constants';
import awsUserLogin from '../api/methods/awsUserLogin';
import awsUserResetPassword from '../api/methods/awsUserResetPassword';
import * as caseActions from '../actions/caseActions.js';
//import { showMessage } from 'react-native-flash-message';
import * as accountActions from '../actions/accountActions';
// import { useNavigate } from 'react-router-dom';
// import { useSnackbar } from 'notistack';
import Api from '../api/index';
import awsUserInfo from '../api/methods/awsUserInfo';

// Our worker Saga that logins the user
export function* login(action) {
  // const { enqueueSnackbar } = useSnackbar();
  try {
    // let navigate = useNavigate();
    console.log('loginSaga:login - Start to login on aws ');
    var user = yield call(awsUserLogin.user, action);
    if (user.username !== undefined) {
      console.log('loginSaga:login - Login successful', action.email);
      //var msg = 'Login successful.';
      //showMessage({message: msg, type: 'success', duration: 6000});
      // hack - update cache with backend phone instead of aws's
      // user.attributes.phone =
      // let enqueueSnackbar = useSnackbar();
      // enqueueSnackbar('Login Successfully', { variant: 'success' });
      //var checkResp = yield put(accountActions.requestGetPhone());
    var token = yield call(awsUserInfo.currentJwtToken);
    var uri = encodeURI('v1/user/phone');
    console.log('call GET url: ', encodeURI(uri));
    const apiResponse = yield Api(encodeURI(uri), null, 'GET', token);
    console.log('Response: ', apiResponse);
    var status = 0;
    if (apiResponse.statusCode === undefined) {
      console.log('accountSaga:getPhoneSaga - Failed to get my phone', apiResponse.message);
      var errorMessage = apiResponse.message === undefined ? '' : apiResponse.message;
      yield put(accountActions.getPhoneFailed(apiResponse.message));
    } else {
      status = apiResponse.statusCode;
    }
    if (status >= 200 && status < 300) {
      yield put(accountActions.onGetPhoneResponse(apiResponse.result));
      console.log('Call accountActions.onGetPhoneResponse ', apiResponse.result);
    } else if (status === 404){ 
        // can not find the account, create one
        var accountRequest = {
          userId: 0,
          firstName: user.attributes.given_name,
          lastName: user.attributes.family_name,
          email: user.attributes.email,
          phone: user.attributes.phone_number, // SOP2 phone store different format as AWS
          status: ''
        }; 
        yield Api('v1/user/', accountRequest, 'POST', token);
    }
    else {
      if (apiResponse.isError === true) {
        errorMessage = apiResponse.message === undefined ? '' : apiResponse.message;
        yield put(accountActions.getPhoneFailed(errorMessage));
      }
    }
      var resp = yield put(caseActions.getAllMyCases());
      console.log('loginSaga:login - Finish getting all my cases.', resp);
      var response = yield put(loginActions.onLoginResponse(user.attributes));
      console.log('Call loginSaga.onLoginResponse ', response);
    } else {
      var message = Constants.LOGIN_ERROR;
      switch (user.code) {
        case 'InvalidParameterException':
        case 'NotAuthorizedException':
          message = "The user name or password you entered isn't correct. Please try again.";
          break;
        case 'UserNotFoundException':
          message = 'User does not exist. Please sign up first by link below: Sign up here.';
          break;
        case 'UserNotConfirmedException':
          message =
            'Your account is not confirmed. Please confirm your account by link below: Confirm a Code.';
          break;
        default:
          break;
      }
      //showMessage({
      // message: message,
      //  type: 'danger',
      //  duration: 6000
      //});
      // enqueueSnackbar(message, { variant: 'error' });
      yield put(loginActions.loginFailed(message));
      console.log('loginSaga:login - Failed to login. Error from AWS:', user.message);
    }
  } catch (error) {
    console.log('loginSaga:login - error signing in: ', error);
    var errMessage = `Login failed. ${error}`;
    console.log('accountSaga:createAccountSaga - ', errMessage);
    //showMessage({ message: errMessage, type: 'danger', duration: 6000 });
    // enqueueSnackbar(error.message, { variant: 'error' });
    yield put(loginActions.loginFailed(error));
  }
}

// Our worker Saga that reset password
export function* resetPasswordSaga(action) {
  try {
    var data = yield call(awsUserResetPassword.forgotPassword, action);
    //var email = action.email;
    if (data.CodeDeliveryDetails !== undefined) {
      //showMessage({
      //  message:
      //    'Confirmation code has been sent to your email. Please check your email for your confirmation code.',
      //  type: 'success',
      //  duration: 6000
      //});
      yield put(loginActions.onResetPasswordResponse());
      //NavigationService.navigate('ConfirmResetPassword', { email: email });
    } else {
      var message = Constants.RESET_PASSWORD_ERROR;
      switch (data.code) {
        case 'InvalidParameterException':
          message = 'Invalid email provided, please try again.';
          break;
        case 'NotAuthorizedException':
          message = "The email you entered isn't correct. Please try again.";
          break;
        case 'InvalidSmsRoleAccessPolicyException':
          message = "The verification code you entered isn't correct. Please try again. ";
          break;
        case 'UserNotConfirmedException':
          message = 'Your account is not confirmed. Please confirm your account.';
          break;
        case 'UserNotFoundException':
          message = "The email you entered isn't correct. Please try again.";
          break;
        default:
          message = data.message;
          break;
      }
      //showMessage({ message: message, type: 'danger', duration: 6000 });
      yield put(loginActions.resetPasswordFailed(message));
      console.log('loginSaga:resetPasswordSaga - Failed to login. Error from AWS:', data.message);
    }
  } catch (error) {
    console.log('loginSaga:resetPasswordSaga - error reset password ', error);
    var errMessage = `Reset password failed. ${error}`;
    //showMessage({ message: errMessage, type: 'danger', duration: 6000 });
    yield put(loginActions.resetPasswordFailed(errMessage));
  }
}

// Our worker Saga that reset password
export function* resetPasswordConfirmSaga(action) {
  try {
    var data = yield call(awsUserResetPassword.forgotPasswordSubmit, action);

    if (data === 'SUCCESS' || data === undefined) {
      //yield put(loginActions.onResetPasswordResponse(data));
      //  yield put(loginActions.disableLoginLoader({}));
      //showMessage({
      //  message: 'Password has been reset successfully.',
      //  type: 'success',
      //  duration: 6000
      //});
      yield put(loginActions.onResetPasswordConfirmResponse());
      //NavigationService.navigate('SignIn');
    } else {
      var message = Constants.RESET_PASSWORD_ERROR;
      switch (data.code) {
        case 'CodeMismatchException':
          message =
            "The verification code you entered isn't correct. Please try again or request a new code. ";
          break;
        case 'ExpiredCodeException':
          message = 'The verification code you entered is expired. Please request a code again. ';
          break;
        default:
          break;
      }
      //showMessage({
      //  message: message,
      //  type: 'danger',
      //  duration: 6000
      //});
      yield put(loginActions.resetPasswordConfirmFailed(message));
      console.log(
        'loginSaga:resetPasswordConfirmSaga - Failed to reset password. Error from AWS:',
        data.code
      );
    }
  } catch (error) {
    console.log('loginSaga:resetPasswordConfirmSaga - error reset password ', error);
    //var errMessage = `Failed to reset password. ${error}`;
    //showMessage({ message: errMessage, type: 'danger', duration: 6000 });
    yield put(loginActions.resetPasswordConfirmFailed(message));
  }
}
